(function () {

  if (window.__mineralSurfaceCalc) return;
  window.__mineralSurfaceCalc = true;

  var lang = (document.documentElement.lang || 'fr').slice(0, 2);

  var I18N = {
    fr: {
      link: 'Calculer ma quantité',
      title: 'Calculez votre surface',
      zone: 'Zone', length: 'Longueur (m)', width: 'Largeur (m)', addZone: '+ Ajouter une zone',
      remove: 'Supprimer', 
      tip: 'Mesurez au plus juste. Vous pourrez ajouter une marge pour les découpes juste après.',
      total: 'Surface totale', cont: 'Continuer', close: 'Fermer',
      error: 'Indiquez une surface supérieure à 0.',
      len: function (n) { return 'Soit ' + n + ' m de longueur'; }
    },
    en: {
      link: 'Calculate my quantity',
      title: 'Calculate your surface area',
      zone: 'Area', length: 'Length (m)', width: 'Width (m)', addZone: '+ Add an area',
      remove: 'Remove', 
      tip: 'Measure as accurately as possible. You can add an allowance for cuts right after.',
      total: 'Total surface', cont: 'Continue', close: 'Close',
      error: 'Enter a surface area greater than 0.',
      len: function (n) { return 'i.e. ' + n + ' m in length'; }
    },
    de: {
      link: 'Menge berechnen',
      title: 'Berechnen Sie Ihre Fläche',
      zone: 'Bereich', length: 'Länge (m)', width: 'Breite (m)', addZone: '+ Bereich hinzufügen',
      remove: 'Entfernen',
      tip: 'Messen Sie so genau wie möglich. Einen Zuschlag für Verschnitt können Sie anschließend hinzufügen.',
      total: 'Gesamtfläche', cont: 'Weiter', close: 'Schließen',
      error: 'Geben Sie eine Fläche größer als 0 an.',
      len: function (n) { return 'entspricht ' + n + ' m Länge'; }
    }
  };
  var T = I18N[lang] || I18N.fr;
  /* unite de surface : vocabulaire unique FR / EN / DE (snippets/unit-label.liquid) */
  var M2 = window.__mpnScM2;

  var ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6h8M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.msc-link{display:inline-flex;align-items:center;gap:8px;margin:10px 0 4px;padding:0;border:0;background:none;color:inherit;font:inherit;font-size:14px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.msc-link:hover{color:#6d9400}' +
    '.msc-panel{position:relative;margin:8px 0 12px;padding:18px 18px 16px;border:1px solid #e6e1d6;background:#fdfaf5;color:#222;font-size:14px;line-height:1.4}' +
    '.msc-panel h3{margin:0 32px 2px 0;font-size:17px;font-weight:500}' +
    '.msc-sub{margin:0 0 14px;font-size:12.5px;color:#777}' +
    '.msc-x{position:absolute;top:8px;right:12px;border:0;background:none;font-size:26px;line-height:1;color:#555;cursor:pointer}' +
    '.msc-zone{display:flex;align-items:flex-end;gap:8px;margin-bottom:10px}' +
    '.msc-field{flex:1;min-width:0}' +
    '.msc-field label{display:block;margin-bottom:4px;font-size:12px;color:#777}' +
    '.msc-step{display:flex;align-items:center;border:1px solid #d9d5c8;background:#fff}' +
    '.msc-step button{flex:none;width:34px;height:40px;border:0;background:none;color:#888;font-size:18px;cursor:pointer}' +
    '.msc-step input{flex:1;min-width:0;width:100%;height:40px;padding:0;border:0;background:none;text-align:center;font:inherit;font-size:16px;-moz-appearance:textfield}' +
    '.msc-step input::-webkit-outer-spin-button,.msc-step input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}' +
    '.msc-times{padding-bottom:10px;color:#999}' +
    '.msc-del{padding:0 0 10px;border:0;background:none;color:#999;font-size:20px;cursor:pointer}' +
    '.msc-add{margin:0 0 12px;padding:0;border:0;background:none;color:#6d9400;font:inherit;font-size:13.5px;text-decoration:underline;cursor:pointer}' +
    '.msc-tip{margin:0 0 12px;font-size:12.5px;color:#777}' +
    '.msc-bottom{display:flex;align-items:center;justify-content:space-between;gap:12px}' +
    '.msc-total{font-weight:600}' +
    '.msc-error{margin:0 0 8px;color:#b3261e;font-size:13px}' +
    '.msc-go{padding:12px 22px;border:0;background:#96c11f;color:#fff;font:inherit;font-size:13.5px;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}' +
    '.msc-go:hover{background:#86ad1b}' +
    '.msc-go:disabled{background:#e5e1d6;color:#a3a095;cursor:default}' +
    /* très petit mobile : longueur et largeur l\'une sous l\'autre */
    '@media (max-width:400px){.msc-zone{flex-wrap:wrap}.msc-zone .msc-field{flex:1 1 100%}.msc-times{display:none}.msc-bottom{flex-wrap:wrap}.msc-go{width:100%}}';
  document.head.appendChild(style);

  /* ---------- menu déplié sous le lien ---------- */

  var panel = null;

  function fmt(n) { return (Math.round(n * 100) / 100).toString().replace('.', ','); }
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) || n < 0 ? 0 : n; }

  function close() {
    if (panel) { panel.remove(); panel = null; }
    var l = document.querySelector('.msc-link');
    if (l) l.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKey, true);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function stepper(cls, label) {
    return '<div class="msc-field"><label>' + label + '</label><div class="msc-step">' +
           '<button type="button" data-d="-1" aria-label="-">−</button>' +
           '<input type="text" inputmode="decimal" autocomplete="off" min="0" step="0.1" placeholder="0" class="' + cls + '">' +
           '<button type="button" data-d="1" aria-label="+">+</button></div></div>';
  }

  function open(link) {

    panel = document.createElement('div');
    panel.className = 'msc-panel';
    panel.innerHTML =
      '<button type="button" class="msc-x" aria-label="' + T.close + '">×</button>' +
      '<h3>' + T.title + '</h3>' +
      '<p class="msc-sub">' + T.tip + '</p>' +
      '<div class="msc-zones"></div>' +
        '<button type="button" class="msc-add">' + T.addZone + '</button>' +
      '<p class="msc-error" hidden>' + T.error + '</p>' +
      '<div class="msc-bottom"><span class="msc-total">' + T.total + ' : <span class="msc-sum">0 ' + M2 + '</span></span>' +
      '<button type="button" class="msc-go">' + T.cont + '</button></div>';

    var zones = panel.querySelector('.msc-zones');
    var sum = panel.querySelector('.msc-sum');
    var err = panel.querySelector('.msc-error');
    var go = panel.querySelector('.msc-go');

    function addZone() {
      var n = zones.children.length + 1;
      var z = document.createElement('div');
      z.className = 'msc-zone';
      z.innerHTML =
        stepper('msc-l', T.length + (n > 1 ? ' · ' + T.zone + ' ' + n : '')) +
        '<span class="msc-times">×</span>' +
        stepper('msc-w', T.width) +
        (n > 1 ? '<button type="button" class="msc-del" aria-label="' + T.remove + '">×</button>' : '');
      zones.appendChild(z);
    }

    function surface() {
      var t = 0;
      zones.querySelectorAll('.msc-zone').forEach(function (z) {
        t += num(z.querySelector('.msc-l').value) * num(z.querySelector('.msc-w').value);
      });
      return t;
    }

    function refresh() {
      var s = surface();
      sum.textContent = fmt(s) + ' ' + M2;
      err.hidden = true;
      go.disabled = !(s > 0);
    }

    addZone();
    refresh();

    panel.addEventListener('input', refresh);

    panel.addEventListener('click', function (e) {

      if (e.target.closest('.msc-x')) { close(); return; }

      var st = e.target.closest('.msc-step button');
      if (st) {
        var inp = st.parentElement.querySelector('input');
        var v = Math.round((num(inp.value) + parseInt(st.dataset.d, 10) * 0.1) * 100) / 100;
        inp.value = v < 0 ? 0 : v;
        refresh();
        return;
      }

      if (e.target.closest('.msc-add')) { addZone(); return; }

      var del = e.target.closest('.msc-del');
      if (del) { del.closest('.msc-zone').remove(); refresh(); return; }

      if (e.target.closest('.msc-go')) {
        var s = surface();
        if (s <= 0) { err.hidden = false; return; }
        apply(s);
        close();
      }
    });

    /* lien dans le titre : le menu se deplie juste sous le titre, avant la case de quantite */
    (link.closest('label') || link).insertAdjacentElement('afterend', panel);
    link.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKey, true);
  }

  function toggle(e) {
    var link = e.currentTarget;
    if (panel) close(); else open(link);
  }

  /* ---------- remplit la surface de la fiche ---------- */

  function apply(m2) {
    var vol = document.querySelector('quantity-calculator .volume__input');
    if (vol) {
      /* fiche avec calculateur (surface + lots) */
      vol.value = Math.ceil(m2 * 100) / 100;
      vol.dispatchEvent(new Event('input', { bubbles: true }));
      vol.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    /* fiche vendue directement au m² : une seule case, nombres entiers -> arrondi au m² superieur */
    var q = document.querySelector('quantity-calculator .quantity__input');
    if (!q) return;
    var min = parseInt(q.min, 10) || 1;
    var step = parseInt(q.step, 10) || 1;
    var v = Math.ceil(Math.round(m2 * 100) / 100 / step - 1e-9) * step;
    q.value = Math.max(min, v);
    /* signale une saisie client (la marge de pose a choix s'applique alors dessus) */
    q.__mpnRelease = true;
    q.dispatchEvent(new Event('input', { bubbles: true }));
    q.dispatchEvent(new Event('change', { bubbles: true }));
    q.__mpnRelease = false;
  }

  /* ---------- le lien « Calculer ma quantité » (m² uniquement) ---------- */

  function ensureLink() {

    var data = document.getElementById('calculator-data');
    var calc = document.querySelector('quantity-calculator');
    var existing = document.querySelector('.msc-link');
    var hasField = calc && (calc.querySelector('.volume__input') || calc.querySelector('.mpn-qty-single .quantity__input'));
    var ok = data && data.dataset.conditionnement === 'm2' && hasField;

    if (!ok) { if (existing) existing.remove(); if (panel) close(); return; }
    if (existing && existing.isConnected && calc.contains(existing)) return;
    if (existing) existing.remove();
    if (panel) close();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'msc-link';
    btn.innerHTML = ICON + '<span>' + T.link + '</span>';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', toggle);

    var lab = calc.querySelector('label.quantity__label');
    var cut = calc.querySelector('.product__cuttings');
    var info = calc.querySelector('.product__qty-infos');
    var row = calc.querySelector('.price-per-item__container');

    /* a droite du titre « Surface a couvrir » (demande d'Ed, oct. 2026) */
    if (lab) { btn.classList.add('msc-in-label'); lab.appendChild(btn); }
    else if (cut) cut.insertAdjacentElement('beforebegin', btn);
    else if (info) info.insertAdjacentElement('afterend', btn);
    else if (row) row.insertAdjacentElement('afterend', btn);
    else calc.appendChild(btn);
  }

  /* ---------- longueur libre : « Soit 6,36 m de longueur » (jamais « ml »), suit la surface choisie ---------- */

  /* texte du produit pour 1 m² : ancien (« Couvre une surface de 6.36 ml ») ou nouveau (« Soit 6,36 m de longueur », oct. 2026) */
  var LEN_RE = /^\s*(?:couvre une surface de|covers an area of|deckt eine fläche von|soit|i\.e\.|entspricht)\s*([\d.,]+)\s*(?:ml|lfm|linear met(?:er|re)s?|linear m|m)\b(?:\s*(?:ab|de longueur|in length|länge))?\s*\.?\s*$/i;
  function fixLen() {
    var calc = document.querySelector('quantity-calculator');
    var el = calc && calc.querySelector('.mpn-lot-detail');
    if (!el) return;
    if (!el.dataset.mpnLen) {
      var m = el.textContent.match(LEN_RE);
      el.dataset.mpnLen = m ? String(parseFloat(m[1].replace(',', '.'))) : '-';
    }
    var per = parseFloat(el.dataset.mpnLen);
    if (!(per > 0)) return;
    var q = calc.querySelector('.volume__input') || calc.querySelector('.mpn-qty-single .quantity__input');
    var s = q ? num(q.value) : 1;
    if (!(s > 0)) s = 1;
    var n = (Math.round(per * s * 100) / 100).toString();
    if (lang !== 'en') n = n.replace('.', ',');
    var t = T.len(n);
    if (el.textContent !== t) el.textContent = t;
  }
  function soon() { setTimeout(fixLen, 30); }
  document.addEventListener('input', soon, true);
  document.addEventListener('change', soon, true);
  document.addEventListener('click', soon, true);

  ensureLink();
  fixLen();
  setInterval(function () { ensureLink(); fixLen(); }, 600);
  /* quand le theme recharge le bloc quantite (changement de format, m² / palette), le lien est remis tout de suite,
     avant l'affichage : il ne disparait plus une demi-seconde (le titre ne saute plus) */
  try {
    var mscBusy = false, mscN = 0, mscT = 0;
    new MutationObserver(function () {
      if (mscBusy) return;
      var now = Date.now(); if (now - mscT > 1000) { mscT = now; mscN = 0; }
      if (++mscN > 30) return;
      mscBusy = true; try { ensureLink(); fixLen(); } finally { mscBusy = false; }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  } catch (e) {}

})();
